import { computed as u, unref as a } from "vue";
function s(e) {
  const n = u(() => {
    const t = a(e.page), r = a(e.offset), l = a(e.pageSize);
    return typeof t == "number" ? t : typeof r == "number" ? Math.ceil(r / l) + 1 : 1;
  }), c = u(() => {
    const t = a(e.pageSize), r = a(e.total);
    return Math.ceil(r / t);
  }), o = u(() => {
    const t = a(e.pageSize);
    return a(e.total) === 0 ? 0 : (n.value - 1) * t + 1;
  }), g = u(() => {
    const t = a(e.pageSize), r = a(e.total);
    return n.value * t > r ? r : n.value * t;
  });
  return {
    currentPage: n,
    pageCount: c,
    start: o,
    end: g
  };
}
export {
  s as default
};
//# sourceMappingURL=design-system.es118.js.map
